import React from "react";
import { withFirebase } from "../Firebase";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";

class RewardPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rewards: [],
      selectedReward: "",
      disableAward: false
    };

    this.onChange = props.onChange;
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.unsubscribe = this.props.firebase
      .xprewards()
      .where("archived", "==", false)
      .orderBy("name")
      .onSnapshot(snapshot => {
        var rewards = [];
        snapshot.docs.forEach(doc => {
          rewards.push({
            ...doc.data(),
            id: doc.id
          });
        });
        this.setState({
          rewards: rewards,
          loading: false
        });
      });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleSelect = event => {
    this.setState({ selectedReward: event.target.value });
  };

  handleAward = () => {
    this.setState({ disableAward: true });
    if (this.state.selectedReward !== "") {
      this.props.awardReward(this.state.selectedReward);
    }
  };

  render() {
    const { open, handleClose } = this.props;
    const { rewards, selectedReward, loading } = this.state;

    return (
      <Dialog
        aria-labelledby="form-dialog-title"
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="form-dialog-title">Reward XP</DialogTitle>
        <DialogContent>
          <DialogContentText>Reward users with XP...</DialogContentText>
          <Select
            disabled={loading}
            value={selectedReward}
            onChange={this.handleSelect}
          >
            {loading && <MenuItem>Loading...</MenuItem>}
            {rewards.map(a => (
              <MenuItem key={a.id} value={a.id}>
                {a.name} ({a.xp})
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button
            onClick={this.handleAward}
            disabled={selectedReward === ""}
            color="primary"
          >
            Award
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withFirebase(RewardPicker);
